import apiCallTemplate from './config'
import credentials from '../assets/credentials'

const {BASE_URL}=credentials
const categoryURL = `${BASE_URL}/categories`;

//create category
export const createCategory=async (data, file)=>apiCallTemplate("post", categoryURL, data, file)

//all category
export const AllCategories=async ()=>apiCallTemplate("get", categoryURL)

//Get category by id
export const getCategoryById=async (id)=>apiCallTemplate("get", `${categoryURL}/${id}`)

//Update category 
export const updateCategory=async (id, data)=>apiCallTemplate("put", `${categoryURL}/${id}`, data)

//Delete category
export const deleteCategory=async (id)=>apiCallTemplate("delete", `${categoryURL}/${id}`)
